import { render, staticRenderFns } from "./myClassDialog.vue?vue&type=template&id=3bab98e7"
import script from "./myClassDialog.vue?vue&type=script&lang=js"
export * from "./myClassDialog.vue?vue&type=script&lang=js"
import style0 from "./myClassDialog.vue?vue&type=style&index=0&id=3bab98e7&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports